import * as actions from 'actions';
import { delay } from 'helpers';
import T from 'prop-types';
import React, { Component } from 'react';
import KeyboardHandler from 'react-key-handler';
import { connect } from 'react-redux';
import { Events, scroller, scrollSpy } from 'react-scroll';
import * as selectors from 'selectors';

class KeyHandler extends Component {
  componentDidMount() {
    Events.scrollEvent.register('begin', () => {
      if (this.scrollInProgress) {
        return;
      }
      this.scrollInProgress = true;
      const wrapper = document.getElementById('wrapper');
      const shouldStartPageTransition =
        wrapper &&
        wrapper.scrollTop >= wrapper.scrollHeight - wrapper.offsetHeight;

      if (shouldStartPageTransition && this.props.page === 'Works') {
        delay(0)
          .then(this.props.startCaseTransition)
          .then(() => {
            this.index = 'scroll-0';
          });
      }
    });

    Events.scrollEvent.register('end', () => {
      this.scrollInProgress = false;
    });

    scrollSpy.update();
  }

  setIndex = (nextIndex) => {
    if (nextIndex === this.index) {
      return true;
    }
    this.index = nextIndex;
    return false;
  };

  scrollDown = (e) => {
    e.preventDefault();
    if (this.scrollInProgress) {
      return;
    }
    const {
      scrollPosition,
      startCaseTransition,
      endCaseTransition,
      caseTransition,
    } = this.props;
    if (caseTransition) {
      return;
    }
    const nextIndex = `scroll-${scrollPosition + 1}`;

    scroller.scrollTo(nextIndex, {
      duration: 300,
      smooth: true,
      containerId: 'wrapper',
      ignoreCancelEvents: true,
    });
  };
  scrollUp = (e) => {
    e.preventDefault();
    if (this.scrollInProgress) {
      return;
    }
    const { scrollPosition } = this.props;

    const nextIndex = `scroll-${scrollPosition - 1}`;

    scroller.scrollTo(nextIndex, {
      duration: 300,
      smooth: true,
      containerId: 'wrapper',
      ignoreCancelEvents: true,
    });
  };

  index = 'scroll-0';
  scrollInProgress = false;

  render() {
    return (
      <React.Fragment>
        <KeyboardHandler
          keyEventName="keydown"
          keyValue="ArrowDown"
          onKeyHandle={this.scrollDown}
        />
        <KeyboardHandler
          keyEventName="keydown"
          keyValue="ArrowUp"
          onKeyHandle={this.scrollUp}
        />
        <KeyboardHandler
          keyEventName="keydown"
          keyValue="Escape"
          onKeyHandle={this.props.resetPopup}
        />
      </React.Fragment>
    );
  }
}

KeyboardHandler.defaultProps = {
  scrollPosition: 0,
};

KeyboardHandler.propTypes = {
  scrollPosition: T.number,
};

const mapStateToProps = state => ({
  scrollPosition: selectors.getScrollPosition(state),
  caseTransition: state.caseTransition,
  page: state.page,
});

const mapDispatchToProps = dispatch => ({
  startCaseTransition: () => dispatch(actions.caseTransitionStart()),
  endCaseTransition: () => dispatch(actions.caseTransitionEnd()),
  resetPopup: () => dispatch(actions.resetPopup()),
});

export default connect(mapStateToProps, mapDispatchToProps)(KeyHandler);



// WEBPACK FOOTER //
// ./src/components/modules/KeyHandler/KeyHandler.js